// CompactShell (DESIGN §3.18.5): Rahmen für schmale Clients (Erweiterung, Mac-Schnellpanel),
// Breite 360–420, Kopf 48, optionale Statusleiste 32, Inhalt scrollt, Fuß fest.
import { ArrowLeft } from '@phosphor-icons/react';
import { type ReactNode } from 'react';
import { cn } from '../kern/cn';
import { Monogram, type Platform } from '../kern/Monogram';
import { ShellIconButton, TooltipProvider } from './parts';

export interface CompactShellProps {
  /** Name des Clients für `main` („Bar side panel“). */
  label: string;
  title: ReactNode;
  platform?: Platform;
  /** Zurück ab Ebene 2. */
  onBack?: () => void;
  actions?: ReactNode;
  /** Avatar 28 mit kompaktem AccountMenu. */
  account?: ReactNode;
  /** Statusleiste (z. B. „Auto-capture on“). */
  status?: ReactNode;
  footer?: ReactNode;
  appName?: string;
  className?: string;
  children: ReactNode;
}

export function CompactShell({
  label,
  title,
  platform = 'ai',
  onBack,
  actions,
  account,
  status,
  footer,
  appName = 'Bar',
  className,
  children,
}: CompactShellProps) {
  return (
    <TooltipProvider delayDuration={400}>
      <main
        aria-label={label}
        className={cn(
          'flex h-dvh max-h-dvh w-full min-w-90 max-w-105 flex-col bg-page text-fg',
          className,
        )}
      >
        <header className="flex h-12 shrink-0 items-center gap-2 px-3">
          {onBack ? (
            <ShellIconButton icon={ArrowLeft} label="Back" size="sm" tone="fg" onClick={onBack} />
          ) : (
            <Monogram size={24} appName={appName} platform={platform} />
          )}
          <h1 className="min-w-0 flex-1 truncate text-label-strong">{title}</h1>
          {actions}
          {account}
        </header>
        {status ? (
          <div className="flex h-8 shrink-0 items-center gap-2 bg-tile px-3 text-small text-fg-secondary">
            {status}
          </div>
        ) : null}
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 py-3">
          {children}
        </div>
        {footer ? <div className="shrink-0 p-3">{footer}</div> : null}
      </main>
    </TooltipProvider>
  );
}
